import { GUEST_TOKEN_URL, SESSION_URL } from './constant';
import { getCookie } from './helper';

interface Token {
    accessToken: string;
    type: 'R' | 'G';
    isLoggedIn: boolean;
    token: string;
    user: Record<string, any> | null;
    userRaw: Record<string, any> | null;
}

interface Options {
    fallbackGuestToken?: boolean;
    reFetchGuestToken?: boolean;
    storagePolicy?: 'local-first' | 'network-first';
}

const isDateBetween = (startDate: string, endDate: string) => {
    const dateToCheckTime = new Date().getTime();
    const startTime = new Date(startDate).getTime();
    const endTime = new Date(endDate).getTime();
    return dateToCheckTime >= startTime && dateToCheckTime <= endTime;
};

const getUserRole = (startDate = '', endDate = '', fallback = 'R') => {
    if (!startDate || !endDate) {
        return fallback;
    }

    if (isDateBetween(startDate, endDate)) {
        return 'P';
    }

    return fallback;
};

const getProfile = (sessionData: Record<string, any>, userRole: string = '') => {
    const { profile, user } = sessionData || {};

    const passportStartDate = user?.['https://1800flowers.com/XAtt4'] || user?.XAtt4 || profile?.XAtt4 || user?.passportStartDate || profile?.passportStartDate || '';
    const passportEndDate = user?.['https://1800flowers.com/XAtt5'] || user?.XAtt5 || user?.passportEndDate || profile?.XAtt5 || profile?.passportEndDate || '';

    return {
        firstName: user?.['https://1800flowers.com/firstName'] || profile?.firstName || '',
        lastName: user?.['https://1800flowers.com/lastName'] || profile?.lastName || '',
        loginsCount: user?.loginsCount || profile?.loginsCount || 0,
        contactId: user?.['https://1800flowers.com/contactId'] || profile?.contactId || 0,
        email: user?.email || profile?.email || '',
        passportFlag: user?.passportFlag || profile?.passportFlag || '',
        passportStartDate,
        passportEndDate,
        userRole: getUserRole(passportStartDate, passportEndDate, userRole) || 'G',
        membershipType: getUserRole(passportStartDate, passportEndDate, userRole) || 'G',
        loyaltyStatus: user?.['https://1800flowers.com/loyaltyStatus'] || user?.loyaltyStatus || profile?.loyaltyStatus || '',
        XAtt4: passportStartDate,
        XAtt5: passportEndDate,
        XAtt3: user?.['https://1800flowers.com/XAtt3'] || user?.XAtt3 || profile?.XAtt3 || ''
    };
};

const useAccessToken = async (options: Options = {}): Promise<Token | null> => {
    const { fallbackGuestToken = true, reFetchGuestToken = false, storagePolicy = 'local-first' } = options || {};
    let userAccessToken: Token | null = null;
    let sessionData: any;
    const userObjectInLocal = global?.window?.localStorage?.getItem?.('userInfo');
    if (storagePolicy === 'network-first' || !userObjectInLocal) {
        try {
            const fetchToken = await fetch(SESSION_URL);
            sessionData = await fetchToken.json();
            const profile = getProfile(sessionData, sessionData?.type);
            global?.window?.localStorage?.setItem?.('userInfo', JSON.stringify({ token: sessionData?.accessToken, profile }));
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (e) {
            console.log(JSON.stringify({ error: e, msg: 'Error useAccessToken' }));
        }
    } else {
        const localStore = userObjectInLocal || '{}';
        sessionData = JSON.parse(localStore);
    }
    const token = sessionData;
    if (token?.accessToken || token?.token) {
        userAccessToken = { user: getProfile(token), userRaw: token.user, accessToken: token?.accessToken || token?.token, type: 'R', isLoggedIn: true, token: token?.accessToken || token?.token };
    } else if (fallbackGuestToken) {
        if (reFetchGuestToken) {
            const guestToken = await fetch(GUEST_TOKEN_URL ?? '', {
                headers: {
                    'content-type': 'application/json;charset=UTF-8'
                },
                method: 'GET'
            });
            let data: Record<string, string> = {};
            try {
                data = await guestToken.json();
                userAccessToken = { user: getProfile({}), userRaw: {}, accessToken: data?.authToken, type: 'G', isLoggedIn: false, token: data?.authToken };
                global?.window?.localStorage?.setItem?.(
                    'userInfo',
                    JSON.stringify({
                        token: data?.authToken,
                        profile: getProfile({})
                    })
                );
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
            } catch (e) {
                userAccessToken = { user: getProfile({}), userRaw: {}, accessToken: '', type: 'G', isLoggedIn: false, token: '' };
            }
        } else {
            userAccessToken = { user: getProfile({}), userRaw: {}, accessToken: getCookie('auth-guest-token'), type: 'G', isLoggedIn: false, token: getCookie('auth-guest-token') };
            global?.window?.localStorage?.setItem?.(
                'userInfo',
                JSON.stringify({
                    token: getCookie('auth-guest-token'),
                    profile: getProfile({})
                })
            );
        }
    }
    return userAccessToken;
};

export default useAccessToken;
